import DateTimeRangePicker from './DateTimeRangePicker.vue'

export default DateTimeRangePicker
